import nxModule from 'nxModule';
import templateUrl from './update-loan-product-types.template.html';
import _ from 'lodash';
import {NxRouteService} from "routes/NxRouteService";
import {CommandService} from "shared/utils/command/command.types";
import ConfirmationTemplate from "shared/common/confirmationTemplate";
import Popup from "shared/common/popup";
import {AttachedFile} from "components/service/file.service";

class UpdateLoanProductTypes {
  private contentFile: AttachedFile[] = [];

  private readonly fileExample = [
    'product_number;target_product_type_code',
    '001-0100-00001-0;0200',
    '002-0200-00002-1;0201'
  ].join('\n');

  private readonly sampleFile = new Blob([this.fileExample], {type: 'text/csv'});

  constructor(private confirmationTemplate: ConfirmationTemplate, private command: CommandService, private $route: NxRouteService, private popup: Popup) {
  }

  async execute() {
    const confirmed = await this.confirmationTemplate({
      question: 'Do you want to process uploaded products?'
    });

    if (confirmed) {
      const executed = await this.command.execute<{fileId: number}, {executionErrors: {productNumber: string, errMessage: string}[]}>('UpdateLoanProductTypes', {
        fileId: this.contentFile[0].id
      }).toPromise();

      const executionErrors = executed.output.executionErrors;
      if (!_.isEmpty(executionErrors)) {
        const header = '<p><span class="red"><strong>WARNING!</strong> Accounts listed below resulted in errors and will not be updated:</span></p>';
        const body: string[] = [];
        _.forEach(executionErrors, err => {
          body.push(...Object.entries(err).map(([errMessage, errValue]) => `<strong>${errMessage}</strong>: ${errValue}<br>`));
        });
        const errorDetails = [header, ...body].join('');
        await this.popup({
          header: 'Upload result',
          text: errorDetails,
          renderHtml: true
        });
      }
      this.$route.reload();
    }
  }

  downloadSampleFile(): void {
    const sampleFileUrl = window.URL.createObjectURL(this.sampleFile);
    const a = document.createElement('a');
    a.href = sampleFileUrl;
    a.download = 'UpdateLoanProductTypes.csv';
    a.click();
  }
}

nxModule.component('updateLoanProductTypes', {
  templateUrl,
  controller: UpdateLoanProductTypes
});
